<template>
  <a
    :href="ALK_BLUEV.link"
    target="_blank"
    class="article-detail-weibo-card font-color-body"
  >
    <div class="card-inner">
      <div class="body">
        <div class="avatar-image">
          <img :src="avatarImg" />
          <span class="icon-bluv">
            <i class="iconfont icon-weibovip"></i>
          </span>
        </div>
        <div class="text">
          <h3 class="title">社会化营销案例库</h3>
          <div class="attrs">
            <span class="official">官方微博</span>
          </div>
        </div>
      </div>
      <div class="footer">
        <p class="desc">
          社会化营销案例库一站搜罗最全最IN的营销案例，为品牌提供可参考复制的社会化营销范本
        </p>
      </div>
    </div>
  </a>
</template>

<script>
import avatarImg from '@/assets/img/common/follow-avator.png'
import { ALK_BLUEV } from '@/global/config'

export default {
  data() {
    return {
      ALK_BLUEV,
      avatarImg
    }
  }
}
</script>

<style lang="scss" scoped>
.article-detail-weibo-card {
  display: block;
  width: 345px;
  height: 156px;
  margin: 64px auto 50px;
  padding: 12px;
  border-radius: 3px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fafafb;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.15);
  .card-inner {
    background-color: #ffffff;
    height: 100%;
    padding: 12px 16px;
    .body {
      display: flex;
    }
    .text {
      min-height: 58px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .avatar-image {
    width: 58px;
    height: 58px;
    position: relative;
    overflow: hidden;
    margin-right: 12px;
    img {
      float: left;
      width: 100%;
      height: 100%;
    }
    .icon-bluv {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 9px;
      background-color: #ffffff;
      i {
        font-size: 14px;
        color: #2fb0f7;
      }
    }
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    margin: 0 0 6px;
  }
  .official {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    border-radius: 10px;
    font-size: 12px;
    color: #f8653f;
    background-color: rgba(248, 101, 63, 0.15);
  }
  .footer {
    margin-top: 8px;
    .desc {
      font-size: 12px;
      color: #727272;
    }
  }
}
</style>
